"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var OptGroup = function OptGroup() {
  return null;
};

OptGroup.isSelectOptGroup = true;
OptGroup.displayName = 'ASelectOptGroup';
var _default = OptGroup;
exports.default = _default;